import { Components, Theme } from '@mui/material';

const MuiCircularProgress: Components<Theme>['MuiCircularProgress'] = {
  styleOverrides: {
    circle: {
      strokeWidth: 4,
    },
    track: ({ theme }) => ({
      stroke: theme.palette.grey[400],
      strokeWidth: 4,
    }),
  },
};

export default MuiCircularProgress;
